import {
  Braces,
  BrainCircuit,
  Cloud,
  Code2,
  LayoutDashboard,
  LifeBuoy,
  RefreshCcw,
  Smartphone,
  Workflow,
} from "lucide-react";
import { PageShell, PageHero } from "../components/PageShell";
import { Reveal } from "../components/Reveal";
import { CtaBanner } from "../components/CtaBanner";
import { services } from "../data/content";

const serviceIcons = [Code2, LayoutDashboard, Smartphone, Braces, Workflow, BrainCircuit, RefreshCcw, Cloud, LifeBuoy];

export default function Services() {
  return (
    <PageShell>
      <div data-testid="services-page">
        <PageHero
          overline="What we do"
          title="Technology Built Around Your Business."
          description="From custom software and enterprise applications to automation, AI integration, cloud solutions, and legacy modernization — we build technology around the way your business works."
        />

        <section className="relative">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            {services.map((service, i) => {
              const Icon = serviceIcons[i];
              const num = String(i + 1).padStart(2, "0");
              return (
                <Reveal key={service.title}>
                  <a
                    href={`/services/${service.slug}`}
                    className="group grid gap-8 border-b border-white/[0.07] py-14 transition-colors duration-300 hover:bg-white/[0.01] lg:grid-cols-12 lg:gap-12 lg:py-20"
                    data-testid={`service-detail-${num}`}
                  >
                    <div className="lg:col-span-2">
                      <span className="text-outline font-display text-6xl lg:text-7xl font-extrabold leading-none transition-all duration-500 group-hover:[-webkit-text-stroke:1px_rgba(0,240,255,0.55)]">
                        {num}
                      </span>
                    </div>
                    <div className="lg:col-span-6">
                      <div className="flex items-center gap-4">
                        <span className="grid h-11 w-11 place-items-center rounded-lg border border-white/10 bg-obsidian transition-colors duration-300 group-hover:border-cyan-400/40">
                          <Icon className="h-5 w-5 text-cyan-400" strokeWidth={1.75} />
                        </span>
                        <h2 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight text-white">
                          {service.title}
                        </h2>
                      </div>
                      <p className="mt-5 text-base sm:text-lg font-medium text-slate-300">
                        {service.short}
                      </p>
                      <p className="mt-3 text-sm sm:text-base leading-relaxed text-slate-400">
                        {service.long}
                      </p>
                    </div>
                  </a>
                </Reveal>
              );
            })}
          </div>
        </section>

        <CtaBanner
          title="Not Sure Which Service Fits?"
          text="Tell us what you are building. We'll help you determine the right way to build it."
        />
      </div>
    </PageShell>
  );
}
